import React from 'react';
import { Redirect } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import HomeConfig from 'app/main/home/HomeConfig';
import ContactConfig from 'app/main/contact/ContactConfig';
import ProductsConfig from 'app/main/products/ProductsConfig';
import MineralsConfig from 'app/main/minerals/MineralsConfig';
import IsoConfig from 'app/main/iso/IsoConfig';

const routeConfigs = [HomeConfig, ContactConfig, ProductsConfig, MineralsConfig, IsoConfig];

const routes = [
	...FuseUtils.generateRoutesFromConfigs(routeConfigs),
	{
		path: '/',
		component: () => <Redirect to="/home" />
	}
];

export default routes;
